module.exports = __webpack_public_path__ + "img/DE05887.b4636f0f.png";